// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/actions.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { TaskActionsService } from "./actions";
import type { TaskActionsServiceGetAllowedBulkActionsResponse } from "./actions";
import type { TaskActionsServiceGetAllowedBulkActionsRequest } from "./actions";
import type { GetTaskActionStateResponse } from "./actions";
import type { GetTaskActionStateRequest } from "./actions";
import type { TaskActionsServiceGetSingleBulkActionProgressByIdResponse } from "./actions";
import type { TaskActionsServiceGetSingleBulkActionProgressByIdRequest } from "./actions";
import type { TaskActionsServiceGetBulkActionProgressByIdResponse } from "./actions";
import type { TaskActionsServiceGetBulkActionProgressByIdRequest } from "./actions";
import type { TaskActionsServiceListBulkActionInProgressResponse } from "./actions";
import type { TaskActionsServiceListBulkActionInProgressRequest } from "./actions";
import type { TaskActionsServiceGetBulkActionProgressResponse } from "./actions";
import type { TaskActionsServiceGetBulkActionProgressRequest } from "./actions";
import type { TaskActionsServiceBulkResponse } from "./actions";
import type { TaskActionsServiceBulkRequest } from "./actions";
import type { TaskActionsServiceUpdateGrantDurationRequest } from "./actions";
import type { TaskActionsServiceUpdateRequestDataRequest } from "./actions";
import type { TaskActionsServiceSkipStepRequest } from "./actions";
import type { TaskActionsServiceMarkProvisionErroredRequest } from "./actions";
import type { TaskActionsServiceMarkProvisionCompleteRequest } from "./actions";
import type { TaskServiceActionResponse } from "./actions";
import type { TaskActionsServiceEscalateToEmergencyAccessRequest } from "./actions";
import type { TaskActionsServiceProcessNowResponse } from "./actions";
import type { TaskActionsServiceProcessNowRequest } from "./actions";
import type { TaskActionsServiceHardResetResponse } from "./actions";
import type { TaskActionsServiceHardResetRequest } from "./actions";
import type { TaskActionsServiceRestartResponse } from "./actions";
import type { TaskActionsServiceRestartRequest } from "./actions";
import type { TaskActionsServiceReassignResponse } from "./actions";
import type { TaskActionsServiceReassignRequest } from "./actions";
import type { TaskActionsServiceCloseResponse } from "./actions";
import type { TaskActionsServiceCloseRequest } from "./actions";
import type { TaskActionsServiceCommentResponse } from "./actions";
import type { TaskActionsServiceCommentRequest } from "./actions";
import type { TaskActionsServiceDenyResponse } from "./actions";
import type { TaskActionsServiceDenyRequest } from "./actions";
import type { TaskActionsServiceApproveWithStepUpResponse } from "./actions";
import type { TaskActionsServiceApproveWithStepUpRequest } from "./actions";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { TaskActionsServiceApproveResponse } from "./actions";
import type { TaskActionsServiceApproveRequest } from "./actions";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.task.v1.TaskActionsService
 */
export interface ITaskActionsServiceClient {
    /**
     * @generated from protobuf rpc: Approve
     */
    approve(input: TaskActionsServiceApproveRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceApproveRequest, TaskActionsServiceApproveResponse>;
    /**
     * @generated from protobuf rpc: ApproveWithStepUp
     */
    approveWithStepUp(input: TaskActionsServiceApproveWithStepUpRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceApproveWithStepUpRequest, TaskActionsServiceApproveWithStepUpResponse>;
    /**
     * @generated from protobuf rpc: Deny
     */
    deny(input: TaskActionsServiceDenyRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceDenyRequest, TaskActionsServiceDenyResponse>;
    /**
     * @generated from protobuf rpc: Comment
     */
    comment(input: TaskActionsServiceCommentRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceCommentRequest, TaskActionsServiceCommentResponse>;
    /**
     * @generated from protobuf rpc: Close
     */
    close$(input: TaskActionsServiceCloseRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceCloseRequest, TaskActionsServiceCloseResponse>;
    /**
     * @generated from protobuf rpc: Reassign
     */
    reassign(input: TaskActionsServiceReassignRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceReassignRequest, TaskActionsServiceReassignResponse>;
    /**
     * @generated from protobuf rpc: Restart
     */
    restart(input: TaskActionsServiceRestartRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceRestartRequest, TaskActionsServiceRestartResponse>;
    /**
     * @generated from protobuf rpc: HardReset
     */
    hardReset(input: TaskActionsServiceHardResetRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceHardResetRequest, TaskActionsServiceHardResetResponse>;
    /**
     * @generated from protobuf rpc: ProcessNow
     */
    processNow(input: TaskActionsServiceProcessNowRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceProcessNowRequest, TaskActionsServiceProcessNowResponse>;
    /**
     * @generated from protobuf rpc: EscalateToEmergencyAccess
     */
    escalateToEmergencyAccess(input: TaskActionsServiceEscalateToEmergencyAccessRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceEscalateToEmergencyAccessRequest, TaskServiceActionResponse>;
    /**
     * @generated from protobuf rpc: MarkProvisionComplete
     */
    markProvisionComplete(input: TaskActionsServiceMarkProvisionCompleteRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceMarkProvisionCompleteRequest, TaskServiceActionResponse>;
    /**
     * @generated from protobuf rpc: MarkProvisionErrored
     */
    markProvisionErrored(input: TaskActionsServiceMarkProvisionErroredRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceMarkProvisionErroredRequest, TaskServiceActionResponse>;
    /**
     * @generated from protobuf rpc: SkipStep
     */
    skipStep(input: TaskActionsServiceSkipStepRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceSkipStepRequest, TaskServiceActionResponse>;
    /**
     * @generated from protobuf rpc: UpdateRequestData
     */
    updateRequestData(input: TaskActionsServiceUpdateRequestDataRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceUpdateRequestDataRequest, TaskServiceActionResponse>;
    /**
     * @generated from protobuf rpc: UpdateGrantDuration
     */
    updateGrantDuration(input: TaskActionsServiceUpdateGrantDurationRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceUpdateGrantDurationRequest, TaskServiceActionResponse>;
    /**
     * @generated from protobuf rpc: BulkRequest
     */
    bulkRequest(input: TaskActionsServiceBulkRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceBulkRequest, TaskActionsServiceBulkResponse>;
    /**
     * @generated from protobuf rpc: GetBulkActionProgress
     */
    getBulkActionProgress(input: TaskActionsServiceGetBulkActionProgressRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceGetBulkActionProgressRequest, TaskActionsServiceGetBulkActionProgressResponse>;
    /**
     * @generated from protobuf rpc: ListBulkActionInProgress
     */
    listBulkActionInProgress(input: TaskActionsServiceListBulkActionInProgressRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceListBulkActionInProgressRequest, TaskActionsServiceListBulkActionInProgressResponse>;
    /**
     * @generated from protobuf rpc: GetBulkActionProgressById
     */
    getBulkActionProgressById(input: TaskActionsServiceGetBulkActionProgressByIdRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceGetBulkActionProgressByIdRequest, TaskActionsServiceGetBulkActionProgressByIdResponse>;
    /**
     * @generated from protobuf rpc: GetSingleBulkActionProgressById
     */
    getSingleBulkActionProgressById(input: TaskActionsServiceGetSingleBulkActionProgressByIdRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceGetSingleBulkActionProgressByIdRequest, TaskActionsServiceGetSingleBulkActionProgressByIdResponse>;
    /**
     * @generated from protobuf rpc: GetTaskActionState
     */
    getTaskActionState(input: GetTaskActionStateRequest, options?: RpcOptions): UnaryCall<GetTaskActionStateRequest, GetTaskActionStateResponse>;
    /**
     * Assuming a generic collection of tasks which are of the given types - return TaskActionTypes which are allowed to be performed in bulk
     *
     * @generated from protobuf rpc: GetAllowedBulkActions
     */
    getAllowedBulkActions(input: TaskActionsServiceGetAllowedBulkActionsRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceGetAllowedBulkActionsRequest, TaskActionsServiceGetAllowedBulkActionsResponse>;
}
/**
 * @generated from protobuf service c1.api.task.v1.TaskActionsService
 */
export class TaskActionsServiceClient implements ITaskActionsServiceClient, ServiceInfo {
    typeName = TaskActionsService.typeName;
    methods = TaskActionsService.methods;
    options = TaskActionsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Approve
     */
    approve(input: TaskActionsServiceApproveRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceApproveRequest, TaskActionsServiceApproveResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceApproveRequest, TaskActionsServiceApproveResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ApproveWithStepUp
     */
    approveWithStepUp(input: TaskActionsServiceApproveWithStepUpRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceApproveWithStepUpRequest, TaskActionsServiceApproveWithStepUpResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceApproveWithStepUpRequest, TaskActionsServiceApproveWithStepUpResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Deny
     */
    deny(input: TaskActionsServiceDenyRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceDenyRequest, TaskActionsServiceDenyResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceDenyRequest, TaskActionsServiceDenyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Comment
     */
    comment(input: TaskActionsServiceCommentRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceCommentRequest, TaskActionsServiceCommentResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceCommentRequest, TaskActionsServiceCommentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Close
     */
    close$(input: TaskActionsServiceCloseRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceCloseRequest, TaskActionsServiceCloseResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceCloseRequest, TaskActionsServiceCloseResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Reassign
     */
    reassign(input: TaskActionsServiceReassignRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceReassignRequest, TaskActionsServiceReassignResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceReassignRequest, TaskActionsServiceReassignResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Restart
     */
    restart(input: TaskActionsServiceRestartRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceRestartRequest, TaskActionsServiceRestartResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceRestartRequest, TaskActionsServiceRestartResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: HardReset
     */
    hardReset(input: TaskActionsServiceHardResetRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceHardResetRequest, TaskActionsServiceHardResetResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceHardResetRequest, TaskActionsServiceHardResetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ProcessNow
     */
    processNow(input: TaskActionsServiceProcessNowRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceProcessNowRequest, TaskActionsServiceProcessNowResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceProcessNowRequest, TaskActionsServiceProcessNowResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EscalateToEmergencyAccess
     */
    escalateToEmergencyAccess(input: TaskActionsServiceEscalateToEmergencyAccessRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceEscalateToEmergencyAccessRequest, TaskServiceActionResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceEscalateToEmergencyAccessRequest, TaskServiceActionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: MarkProvisionComplete
     */
    markProvisionComplete(input: TaskActionsServiceMarkProvisionCompleteRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceMarkProvisionCompleteRequest, TaskServiceActionResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceMarkProvisionCompleteRequest, TaskServiceActionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: MarkProvisionErrored
     */
    markProvisionErrored(input: TaskActionsServiceMarkProvisionErroredRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceMarkProvisionErroredRequest, TaskServiceActionResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceMarkProvisionErroredRequest, TaskServiceActionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SkipStep
     */
    skipStep(input: TaskActionsServiceSkipStepRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceSkipStepRequest, TaskServiceActionResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceSkipStepRequest, TaskServiceActionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateRequestData
     */
    updateRequestData(input: TaskActionsServiceUpdateRequestDataRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceUpdateRequestDataRequest, TaskServiceActionResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceUpdateRequestDataRequest, TaskServiceActionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateGrantDuration
     */
    updateGrantDuration(input: TaskActionsServiceUpdateGrantDurationRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceUpdateGrantDurationRequest, TaskServiceActionResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceUpdateGrantDurationRequest, TaskServiceActionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkRequest
     */
    bulkRequest(input: TaskActionsServiceBulkRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceBulkRequest, TaskActionsServiceBulkResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceBulkRequest, TaskActionsServiceBulkResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetBulkActionProgress
     */
    getBulkActionProgress(input: TaskActionsServiceGetBulkActionProgressRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceGetBulkActionProgressRequest, TaskActionsServiceGetBulkActionProgressResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceGetBulkActionProgressRequest, TaskActionsServiceGetBulkActionProgressResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListBulkActionInProgress
     */
    listBulkActionInProgress(input: TaskActionsServiceListBulkActionInProgressRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceListBulkActionInProgressRequest, TaskActionsServiceListBulkActionInProgressResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceListBulkActionInProgressRequest, TaskActionsServiceListBulkActionInProgressResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetBulkActionProgressById
     */
    getBulkActionProgressById(input: TaskActionsServiceGetBulkActionProgressByIdRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceGetBulkActionProgressByIdRequest, TaskActionsServiceGetBulkActionProgressByIdResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceGetBulkActionProgressByIdRequest, TaskActionsServiceGetBulkActionProgressByIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSingleBulkActionProgressById
     */
    getSingleBulkActionProgressById(input: TaskActionsServiceGetSingleBulkActionProgressByIdRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceGetSingleBulkActionProgressByIdRequest, TaskActionsServiceGetSingleBulkActionProgressByIdResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceGetSingleBulkActionProgressByIdRequest, TaskActionsServiceGetSingleBulkActionProgressByIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetTaskActionState
     */
    getTaskActionState(input: GetTaskActionStateRequest, options?: RpcOptions): UnaryCall<GetTaskActionStateRequest, GetTaskActionStateResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetTaskActionStateRequest, GetTaskActionStateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Assuming a generic collection of tasks which are of the given types - return TaskActionTypes which are allowed to be performed in bulk
     *
     * @generated from protobuf rpc: GetAllowedBulkActions
     */
    getAllowedBulkActions(input: TaskActionsServiceGetAllowedBulkActionsRequest, options?: RpcOptions): UnaryCall<TaskActionsServiceGetAllowedBulkActionsRequest, TaskActionsServiceGetAllowedBulkActionsResponse> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskActionsServiceGetAllowedBulkActionsRequest, TaskActionsServiceGetAllowedBulkActionsResponse>("unary", this._transport, method, opt, input);
    }
}
